import { z } from "zod";

// POST /groups/group_create returns backend GroupResponse, not StandardResponse.
// Keep this wire schema separate from list/detail schemas that coerce IDs for UI state.
const memberSchema = z.object({
  uuid: z.string().uuid(),
  id: z.number().int().nullish(),
  first_name: z.string().nullish(),
  last_name: z.string().nullish(),
  email: z.string().nullish(),
  is_active: z.boolean(),
  is_invited: z.boolean(),
  is_onboarded: z.boolean(),
  is_verified: z.boolean(),
  deleted_at: z.string().nullish(),
});

const ruleFields = {
  id: z.number().int(),
  user_group_id: z.number().int(),
  entity_type: z.string(),
  is_active: z.boolean(),
  is_deleted: z.boolean(),
  created_by: z.string(),
  updated_by: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  grouping: z.string().nullish(),
};

export const CreateTeamResponseSchema = z.object({
  id: z.number().int(),
  uuid: z.string().uuid(),
  symbol: z.string().nullish(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  users: z.array(memberSchema),
  user_group_rules: z.array(z.object({ ...ruleFields, rule: z.record(z.unknown()) })).nullish(),
  user_group_ownership: z
    .array(z.object({ ...ruleFields, ownership_rule: z.record(z.unknown()) }))
    .nullish(),
  is_owner: z.boolean().nullish(),
  has_conflicts: z.boolean().nullish(),
  created_at: z.string().nullish(),
  updated_at: z.string().nullish(),
  created_by: z.number().int().nullish(),
  updated_by: z.number().int().nullish(),
  is_deleted: z.boolean().nullish(),
  deleted_at: z.string().nullish(),
});

export type CreateTeamResponse = z.infer<typeof CreateTeamResponseSchema>;
